import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/home'),
        name: 'Home'
      },
      {
        path: '/doc',
        redirect: '/doc/index',
        component: () => import('@/views/doc'),
        children: [
          {
            path: 'index',
            component: () => import('@/views/doc/index')
          },
          {
            path: 'sign-request',
            component: () => import('@/views/doc/sign-request')
          },
          {
            path: 'sign-success-notify',
            component: () => import('@/views/doc/sign-success-notify')
          },
          {
            path: 'contract-invalid',
            component: () => import('@/views/doc/contract-invalid')
          },
          {
            path: 'contract-status',
            component: () => import('@/views/doc/contract-status')
          },
          {
            path: 'sdk',
            component: () => import('@/views/doc/sdk')
          },
          {
            path: 'template-search',
            component: () => import('@/views/doc/template-search')
          },
          {
            path: 'sign-request-v2',
            component: () => import('@/views/doc/sign-request-v2')
          },
        ]
      }]
  }]
})
export default router